import { css } from 'styled-components';
import token from 'styled-token';

/** @class PropertyCardPhotoWrapperMixin */
/** @method */
export var PropertyCardPhotoWrapperMixin = function PropertyCardPhotoWrapperMixin() {
  return token({
    borderRadius: 'PropertyCard.photo.borderRadius',
    templateRows: 'PropertyCard.photo.templateRows'
  }, function (_ref) {
    var borderRadius = _ref.borderRadius,
      _ref$templateRows = _ref.templateRows,
      templateRows = _ref$templateRows === void 0 ? 'auto 1fr auto' : _ref$templateRows;
    return css(["display:grid;grid-area:photo;grid-template-areas:'photo-top' 'photo-center' 'photo-bottom';grid-template-rows:", ";border-radius:", "px;"], templateRows, borderRadius);
  });
};